export default __webpack_public_path__ + "static/media/logo.57f003fb.png";